module.exports = "../../app/cells/components/modals/setup_wizard/military_exam.erb";